import { useTranslation } from 'react-i18next';
import { Icon } from '@aqarmap/aqarmap-ui';
import ToggleWhatsapp from '~/components/ToggleWhatsapp';
import { openModal } from '~/redux/features/uiState/uiStateSlice';
import { useAppDispatch } from '~/redux/hooks';

const ContactItem = ({
  item,
  onDeleteItem,
  disabled,
}: {
  item: {
    id: number;
    phone: { number: string };
    whats_app: boolean;
    main: boolean;
  };
  onDeleteItem: (id: number) => void;
  disabled: boolean;
}) => {
  const { t, i18n } = useTranslation('app');
  const locale = i18n.language;
  const dispatch = useAppDispatch();

  return (
    <li className="mt-1.5x px-3x border-b border-gray last-of-type:border-none pb-2x last-of-type:pb-0">
      <div className="flex items-start justify-between">
        <div>
          <p
            style={{ direction: 'ltr' }}
            className={`text-body_1 text-gray__dark_1 mb-0.5x ${locale === 'ar' ? 'text-end' : ''}`}
          >
            {item.phone.number}
          </p>
          <div className="flex items-center gap-2x">
            <div className="flex items-center gap-x">
              <Icon name="whatsapp" className="text-green_light" />
              <p className="text-body_2 text-gray__dark_1">
                {t('whatsappAvailable')}
              </p>
            </div>
            <ToggleWhatsapp item={item} />
          </div>
        </div>
        <button
          onClick={() => {
            dispatch(openModal('deleteNumber'));
            onDeleteItem(item.id);
          }}
          type="button"
          disabled={disabled}
          aria-label="delete-btn"
        >
          <Icon
            name="trash"
            className={`${disabled ? 'text-gray' : 'text-red_dark'}`}
          />
        </button>
      </div>
    </li>
  );
};

export default ContactItem;
